import { render, staticRenderFns } from "./ModalLinkAction.vue?vue&type=template&id=fa9a3054"
import script from "./ModalLinkAction.vue?vue&type=script&lang=ts"
export * from "./ModalLinkAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports